import logo from "./logo.svg";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./index.css";

import Home from "./pages/Home";
import About from "./pages/About";

import Header from "./components/Header";
import Footer from "./components/Footer";
// import Navbar from "./components/Navbar";

function App() {
  return (
    <div>
      <BrowserRouter>
        <Header />
        {/* <About /> */}
        <Routes>
          <Route index element={<Home />} />
          <Route path="/about" element={<About />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
